/* global jQuery */
/**
 * Datepicker
 * @author RMa, Unic AG
 * @edited OrT, Unic AG
 * @edited HaJ, Unic AG
 * @license All rights reserved Unic AG
 */

(function($, undefined) {
	'use strict';

	var name = 'flexdatepicker',
		events = {/* eventname: name +'_eventname' */},
		defaults = {/* defaults */},
		data = {
		// items: ["Item 1", "Item 2"]
	};

	/**
	 * Create an instance of the module
	 * @param {object} element The DOM element to bind the module
	 * @param {object} options Options overwriting the defaults
	 * @constructor
	 */
	function Module(element, options) {
		this._helper = estatico.helpers.SuperClass;

		this._helper({
			name: name,
			element: element,
			defaults: defaults,
			options: options,
			events: events,
			data: data
		});
	}

	Module.prototype = $.extend(true, {}, estatico.helpers.SuperClass.prototype, Module.prototype);

	/**
	 * Initialize module, bind events
	 */
	Module.prototype.init = function() {
		// init method
	};

	/**
	 * Unbind events, remove data, custom teardown
	 * @method
	 * @public
	 */
	Module.prototype.destroy = function() {
		// Unbind events, remove data
		estatico.helpers.SuperClass.prototype.destroy.apply(this);

		// Custom teardown (removing added DOM elements etc.)
		// If there is no need for a custom teardown, this method can be removed
	};

	// Make the plugin available through jQuery (and the global project namespace)
	estatico.helpers.SuperClass.register(Module, name, {
		initEvents: ['ready', 'ajaxload'],
		events: events
	});

	if ($.validator) {
		// Correct Validator to current Format
		$.validator.methods.date = function(value, input) {
			var validDate = false,
				dateFormat = 'MM.DD.YYYY',
				dateSeparator,
				dateYearIndex = 2,
				dateMonthIndex = 0,
				dateDayIndex = 1;

			// Read dateFormat from data-attribute
			while (input.parentElement && !input.dataset.flexdatepickerOptions) {
				input = input.parentElement;
			}

			if (input.dataset.flexdatepickerOptions) {
				dateFormat = JSON.parse(input.dataset.flexdatepickerOptions).dateFormat;
			}

			// find the separator sign
			dateSeparator = dateFormat.replace(/\w/g, '').split('')[0];
			dateFormat = dateFormat.toUpperCase().split(dateSeparator);

			// find the order of year, month and day in dateFormat
			$.each(dateFormat, function(index, datePartial) {
				if (datePartial.search('Y') !== -1) {
					dateYearIndex = index;
				}

				if (datePartial.search('M') !== -1) {
					dateMonthIndex = index;
				}

				if (datePartial.search('D') !== -1) {
					dateDayIndex = index;
				}
			});

			// validate only when there is any value set
			if (value) {
				try {
					var dateArray = value.split(dateSeparator),
						date = new Date(dateArray[dateYearIndex], parseInt(dateArray[dateMonthIndex], 10) - 1, dateArray[dateDayIndex]);

					// check if ay is valid
					if (dateArray[dateDayIndex] > 31) {
						return false;
					}

					// check if month is valid
					if (dateArray[dateMonthIndex] > 12) {
						return false;
					}

					if (!isNaN(date.getTime())) {
						validDate = true;
					}
				} catch (ex) {
					validDate = false;
				}
			} else {
				validDate = true;
			}

			return validDate;
		}.bind(this);
	}

})(jQuery);
